import React from "react";
import styles from "./button.module.css";

function SecondaryButton({ title }) {
  return <button className={styles.secondaryBtn}>{title}</button>;
}

export default SecondaryButton;
